import styled, { css } from 'styled-components';
import { MapContainer } from 'react-leaflet';
import { em, rem } from 'styles';
import { PALETTE, RECORD_BAR_HEIGHT } from '../../fields.constants';

export const MapHolder = styled.div`
  position: relative;
  width: 100%;
  height: ${em(520)};
  isolation: isolate;

  ${({ $hasBanner }) =>
    $hasBanner &&
    css`
      .leaflet-top {
        margin-top: ${em(RECORD_BAR_HEIGHT)};
      }
    `}
`;

export const StyledMapContainer = styled(MapContainer)`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    border-radius: ${em(theme.radius[0])};
    overflow: hidden;
  `}

  .stone-tip {
    width: max-content;
    max-width: ${em(250)};
    padding: ${em(9)} ${em(11)};
    font-size: ${rem(12.5)};
    color: ${PALETTE.ink};
    white-space: normal;
    background: #fff;
    border: ${em(1)} solid ${PALETTE.line};
    border-radius: ${em(6)};
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.18);
  }

  .stone-tip::before {
    display: none;
  }

  .stone-tip-title {
    font-size: ${rem(14)};
    font-weight: 700;
  }

  .stone-tip-est {
    font-size: ${rem(11.5)};
    font-style: italic;
    color: ${PALETTE.faint};
  }

  .stone-tip-row {
    margin-top: ${em(2)};
    color: ${PALETTE.muted};
  }

  .leaflet-control-scale-line {
    padding: 0 0 ${em(3)};
    font-size: ${rem(11.5)};
    line-height: 1.2;
    color: #fff;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
    background: none;
    border: ${em(1.5)} solid #fff;
    border-top: none;
  }
`;

export const Toolbar = styled.div`
  position: absolute;
  top: ${({ $hasBanner }) => em($hasBanner ? RECORD_BAR_HEIGHT + 12 : 12)};
  left: ${em(12)};
  z-index: ${({ theme }) => theme.zIndexes[3]};
  display: flex;
  gap: ${em(6)};
`;

export const ToolbarButton = styled.button`
  padding: ${em(5)} ${em(11)};
  font-size: ${rem(13)};
  color: ${PALETTE.muted};
  background: rgba(255, 255, 255, 0.92);
  border: ${em(1)} solid rgba(0, 0, 0, 0.12);
  border-radius: ${em(6)};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.14);
  cursor: pointer;

  &[aria-pressed='true'] {
    font-weight: 500;
    color: ${PALETTE.ink};
    background: #fff;
  }
`;

export const Banner = styled.div`
  ${({ theme }) => css`
    position: absolute;
    left: ${em(10)};
    right: ${em(10)};
    bottom: ${em(10)};
    z-index: ${theme.zIndexes[3]};
    padding: ${em(9)} ${em(12)};
    background: rgba(255, 255, 255, 0.96);
    border: ${theme.borders.default({ fontSize: theme.fontSizes[2] })};
    border-left: ${em(3)} solid ${theme.colors.status.late};
    border-radius: ${em(theme.radius[0])};
    font-size: ${rem(14)};
    color: ${theme.colors.nature.n5};
  `}
`;

export const Legend = styled.div`
  position: absolute;
  right: ${em(12)};
  bottom: ${em(34)};
  z-index: ${({ theme }) => theme.zIndexes[3]};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${em(6)};
  padding: ${em(10)} ${em(12)};
  font-size: ${rem(12.5)};
  color: ${PALETTE.muted};
  background: rgba(255, 255, 255, 0.94);
  border: ${em(1)} solid rgba(0, 0, 0, 0.1);
  border-radius: ${em(6)};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16);
`;

export const Swatch = styled.span`
  flex: none;
  width: ${em(17)};
  height: ${em(9)};
  background: rgba(255, 255, 255, 0.75);
  border: ${em(1)} solid rgba(0, 0, 0, 0.2);
  border-radius: ${em(2)};
`;

export const LegendRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${em(8)};
`;

export const Dot = styled.span`
  flex: none;
  width: ${em(11)};
  height: ${em(11)};
  background: ${({ $color }) => $color};
  border: ${em(1)} solid rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  ${({ $ring }) =>
    $ring &&
    css`
      box-shadow: inset 0 0 0 ${em(1.5)} rgba(20, 28, 24, 0.8);
    `}
`;

export const Mark = styled.span`
  flex: none;
  display: flex;
  justify-content: center;
  width: ${em(17)};
`;

export const RiskSquare = styled.span`
  flex: none;
  width: ${({ $size }) => em($size)};
  height: ${({ $size }) => em($size)};
  background: ${({ $color }) => $color};
  border: ${em(1.5)} solid #fff;
  border-radius: ${em(2)};
  box-shadow: 0 0 0 ${em(1)} rgba(0, 0, 0, 0.25);
`;

export const LegendButton = styled.button`
  display: block;
  width: 100%;
  margin-top: ${em(6)};
  padding: ${em(4)} 0 0;
  font-size: ${rem(11.5)};
  font-weight: 600;
  color: #2f5e86;
  text-align: left;
  text-decoration: underline;
  background: none;
  border: 0;
  border-top: ${em(1)} solid ${PALETTE.line};
  cursor: pointer;
`;
